import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const GiltGroupe = ({featuredProjectsList}) => {
  const project = getProject('gilt-groupe');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170510163317/header-gilt.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            Gilt Groupe’s digital presence consisted of an uneven collection of
            online properties, identities and sites. Through close
            collaboration, Your Majesty created a new visual identity, optimized
            the shopping experience and achieved a more profitable eCommerce
            platform.
          </p>
        </AnimateIn>

        <Image
          className="component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170503204844/gilt-brand1.jpg'
          }}
        />

        <Image
          className="component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170503204847/gilt-brand3.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170503204845/gilt-brand2.jpg',
            caption: 'Gilt “Inspire Every Day” universe'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="an-exceptional-shopping-experience">
            An exceptional shopping experience
          </h2>
          <p>
            A cohesive visual identity familiarized the brand across all web
            properties, brand identities, packaging and collateral. New content
            types, such as advice from top designers, were introduced to
            shoppers to engage them in longer and more frequent visits.
            Data-driven research was applied to simplify the purchasing
            experience, ensuring all products to be only 2 clicks away from the
            cart.
          </p>
        </AnimateIn>

        <Quote
          className="g-row quote--marks"
          component={{
            quote:
              'We love the team at Your Majesty. In 2011 we were looking for a creative agency to act as an extension to our internal creative team. Your Majesty integrated seamlessly into our workflow and was a valuable partner in our redesign efforts.',
            quotee: 'Stephen Spyropoulos, VP of UX and Design'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170503204855/gilt-site1.jpg',
            caption: 'Gilt Women'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170503204857/gilt-site2.jpg',
            caption: 'Gilt Men'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170503204858/gilt-site3.jpg',
            caption: 'Gilt Home'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="outcomes">Outcomes</h2>
          <ul>
            <li>
              Armed with the new redesign, Gilt Groupe rose to a perfect storm
              in their personalized daily sales, selling out 70% of each sale
              within 90 minutes.
            </li>
            <li>
              Webby Awards - Fashion &amp; Beauty - People’s Choice Winner
            </li>
            <li>Webby Awards - Best User Experience - Honoree</li>
          </ul>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Brand Strategy',
                  'Creative Strategy',
                  'Interviews & User Testing',
                  'Product Strategy',
                  'Prototyping & Validation'
                ]
              },

              {
                title: 'Design',
                items: [
                  'Art Direction',
                  'Brand Design',
                  'UI/UX Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'eCommerce',
                  'Front-end Development',
                  'Functional Prototyping'
                ]
              },

              {
                title: 'Delivery',
                items: [
                  'A/B Testing',
                  'Multivariate Testing',
                  'Quantitative and Qualitative Analysis'
                ]
              }
            ]
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default GiltGroupe;
